export enum Status {
    Active = 'active',
    WaitingForApproval = 'waiting',
    Closed = 'closed',
    Suspended = 'suspended',
    Payment = 'payment',
    Scheduled = 'scheduled',
    Stopped = 'stopped',
    NotApproved = 'not_approved',
    Draft = 'draft'
}

export enum PaymentStatus {
    Accepted = 'accepted',
    Pending = 'pending',
    Refunded = 'refunded',
    NotApplicable = 'not applicable',
    Rejected = 'rejected',
    PartialRefund = 'partial refund'
}
